import { useLocation, useNavigate } from 'react-router-dom';

import type { NavigateFunction, NavigateOptions, To } from 'react-router-dom';

type EnhancedNavigateOptions = NavigateOptions & { merge?: boolean };

interface EnhancedNavigateFunction extends NavigateFunction {
  (to: To, options?: EnhancedNavigateOptions): void;
}

export const useEnhancedNavigate = (): EnhancedNavigateFunction => {
  const navigate = useNavigate();
  const location = useLocation();

  const fn: EnhancedNavigateFunction = (
    move: To | number,
    options?: EnhancedNavigateOptions,
  ) => {
    if (typeof move === 'number') {
      navigate(move);
      return;
    }

    if (typeof move === 'string') {
      navigate(move, options);
      return;
    }

    if (options.merge) {
      navigate({ ...location, ...move }, options);
    }
  };

  return fn;
};
